import { TDeviceType } from '@cian/ui-kit';

interface IParams {
  visibleSlides?: number;
  gap?: number;
  padding?: number;
  viewportWidth?: number;
}

type TSliderConfig = Record<TDeviceType, IParams>;

export const SLIDER_CONFIG: TSliderConfig = {
  phone: {
    visibleSlides: 1,
    gap: 8,
    padding: 16,
  },
  tablet: {
    visibleSlides: 2,
    gap: 16,
    viewportWidth: 600,
  },
  desktop: {},
};
